import * as labelCollatedPdfIcon from '~/assets/icons/print-format/collated_pdf.svg';
import * as label8x11PdfWithSlipIcon from '~/assets/icons/print-format/combo_ol_ps.svg';
import * as labelZplIcon from '~/assets/icons/print-format/label_img_zplii.svg';
import * as label2p3x7p5PdfIcon from '~/assets/icons/print-format/label_pdf_2p3x7p5.svg';
import * as label4x8PdfIcon from '~/assets/icons/print-format/label_pdf_4x8.svg';
import * as label8x11PdfIcon from '~/assets/icons/print-format/label_pdf_8x11.svg';
import * as labelA4PdfIcon from '~/assets/icons/print-format/label_pdf_a4.svg';
import * as labelA6PdfIcon from '~/assets/icons/print-format/label_pdf_a6.svg';
import * as label4x6PdfIcon from '~/assets/icons/print-format/label_pdf_thermal_4x6.svg';
import * as label2p3x7p5PngIcon from '~/assets/icons/print-format/label_png_2p3x7p5.svg';
import * as labelPngIcon from '~/assets/icons/print-format/label_png_original.svg';

enum LabelFormat {
  PDF = 'PDF',
  PDF_W_PSLIP_8x11 = 'PDF_W_PSLIP_8x11',
  PDF_SINGLE_8X11 = 'PDF_SINGLE_8X11',
  PDF_4x6 = 'PDF_4x6',
  PDF_4x8 = 'PDF_4x8',
  PDF_2_3x7_5 = 'PDF_2.3x7.5',
  PNG_2_3x7_5 = 'PNG_2.3x7.5',
  PDF_A4 = 'PDF_A4',
  PDF_A6 = 'PDF_A6',
  PNG = 'PNG',
  ZPLII = 'ZPLII',
  PDF_W_PSLIP_COLLATED_8x11 = 'PDF_W_PSLIP_COLLATED_8x11',
  PDF_W_PSLIP_COLLATED_4x6 = 'PDF_W_PSLIP_COLLATED_4x6',
  PDF_W_PSLIP_COLLATED_4x8 = 'PDF_W_PSLIP_COLLATED_4x8',
}

const DefaultLabelFormat: LabelFormat = LabelFormat.PDF;

const LabelFormatIcons: HashMap<LabelFormat, string> = {
  [LabelFormat.PDF]: label8x11PdfIcon,
  [LabelFormat.PDF_W_PSLIP_8x11]: label8x11PdfWithSlipIcon,
  [LabelFormat.PDF_SINGLE_8X11]: label8x11PdfIcon,
  [LabelFormat.PDF_4x6]: label4x6PdfIcon,
  [LabelFormat.PDF_4x8]: label4x8PdfIcon,
  [LabelFormat.PDF_2_3x7_5]: label2p3x7p5PdfIcon,
  [LabelFormat.PNG_2_3x7_5]: label2p3x7p5PngIcon,
  [LabelFormat.PDF_A4]: labelA4PdfIcon,
  [LabelFormat.PDF_A6]: labelA6PdfIcon,
  [LabelFormat.PNG]: labelPngIcon,
  [LabelFormat.ZPLII]: labelZplIcon,
  [LabelFormat.PDF_W_PSLIP_COLLATED_8x11]: labelCollatedPdfIcon,
  [LabelFormat.PDF_W_PSLIP_COLLATED_4x6]: labelCollatedPdfIcon,
  [LabelFormat.PDF_W_PSLIP_COLLATED_4x8]: labelCollatedPdfIcon,
};

const isMergedLabelFormat = (labelFormat: LabelFormat) => {
  return (
    labelFormat === LabelFormat.PDF_W_PSLIP_8x11 ||
    labelFormat === LabelFormat.PDF_W_PSLIP_COLLATED_8x11 ||
    labelFormat === LabelFormat.PDF_W_PSLIP_COLLATED_4x6 ||
    labelFormat === LabelFormat.PDF_W_PSLIP_COLLATED_4x8
  );
};

export { DefaultLabelFormat, LabelFormatIcons, isMergedLabelFormat };

export default LabelFormat;
